import React from 'react';
import { tokens } from '@welbe/web-design-system';
import { IconProps } from './types';

export const MoreUser = ({
	width = '18',
	height = '16',
	color = tokens.color_white,
}: IconProps): JSX.Element => {
	return (
		<svg width={width} height={height} viewBox="0 0 18 16" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 0.5C4.19881 0.5 2.33333 2.36548 2.33333 4.66667C2.33333 6.96785 4.19881 8.83333 6.5 8.83333C8.80119 8.83333 10.6667 6.96785 10.6667 4.66667C10.6667 2.36548 8.80119 0.5 6.5 0.5ZM4 4.66667C4 3.28595 5.11929 2.16667 6.5 2.16667C7.88071 2.16667 9 3.28595 9 4.66667C9 6.04738 7.88071 7.16667 6.5 7.16667C5.11929 7.16667 4 6.04738 4 4.66667Z"
				fill={color}
			/>
			<path
				d="M6.50002 10.5C5.21591 10.5 3.96767 10.9237 2.94891 11.7054C1.93016 12.4872 1.19781 13.5832 0.865455 14.8236C0.746337 15.2681 1.01016 15.7251 1.45471 15.8442C1.89927 15.9633 2.35621 15.6995 2.47533 15.2549C2.71273 14.3689 3.23583 13.5861 3.96352 13.0277C4.6912 12.4693 5.5828 12.1667 6.50002 12.1667C7.41725 12.1667 8.30885 12.4693 9.03653 13.0277C9.76421 13.5861 10.2873 14.3689 10.5247 15.2549C10.6438 15.6995 11.1008 15.9633 11.5453 15.8442C11.9899 15.7251 12.2537 15.2681 12.1346 14.8236C11.8022 13.5832 11.0699 12.4872 10.0511 11.7054C9.03237 10.9237 7.78414 10.5 6.50002 10.5Z"
				fill={color}
			/>
			<path
				d="M14.8333 6.33331C14.8333 5.87307 14.4602 5.49997 14 5.49997C13.5398 5.49997 13.1667 5.87307 13.1667 6.33331V7.99999L11.5 7.99999C11.0397 7.99999 10.6667 8.37309 10.6667 8.83333C10.6667 9.29356 11.0397 9.66666 11.5 9.66666L13.1667 9.66666V11.3333C13.1667 11.7935 13.5398 12.1666 14 12.1666C14.4602 12.1666 14.8333 11.7935 14.8333 11.3333V9.66666H16.5C16.9602 9.66666 17.3333 9.29356 17.3333 8.83333C17.3333 8.37309 16.9602 7.99999 16.5 7.99999H14.8333V6.33331Z"
				fill={color}
			/>
		</svg>
	);
};
